/* eslint-disable */
import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import InvoiceService from 'src/services/invoice.service';

export const useAddInvoice = (): UseMutationResult<any, Error, { invoice: FormData }, void> =>
  useMutation((data: { invoice: FormData }) => InvoiceService.addInvoice(data.invoice), {
    onSuccess: () => {
      AlertAdapter('Invoice has been created.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

// export const useUpdateInvoice = (): UseMutationResult<any, Error, { invoice: FormData , invoiceId : any}, void> =>
//   useMutation((data: { invoice: FormData},invoiceId ) => InvoiceService.updateInvoice(data.invoice, invoiceId), {
//     onSuccess: () => {
//       AlertAdapter('Invoice has been updated.', 'success');
//     },
//     onError: (e: Error) => {
//       AlertAdapter(e.message, 'error');
//     },
//   });

export const useUpdateInvoice = (): UseMutationResult<any, Error, { invoice: FormData; invoiceId: any }, void> =>
  useMutation(({ invoice, invoiceId }) => InvoiceService.updateInvoice(invoice, invoiceId), {
    onSuccess: () => {
      AlertAdapter('Invoice has been updated.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useResubmitInvoice = (): UseMutationResult<any, Error, { invoice: FormData; invoiceId: any }, void> =>
  useMutation(({ invoice, invoiceId }) => InvoiceService.resubmitInvoice(invoice, invoiceId), {
    onSuccess: () => {
      AlertAdapter('Invoice has been updated.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useOverideInvoice = (): UseMutationResult<any, Error, { invoice: FormData; invoiceId: any }, void> =>
  useMutation(({ invoice, invoiceId }) => InvoiceService.overrideInvoice(invoice, invoiceId), {
    onSuccess: () => {
      AlertAdapter('Invoice has been updated.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useApproveInvocie = (): UseMutationResult<any, Error, { invoiceId: string; invoice: any }, void> =>
  useMutation(
    ({ invoiceId, invoice }: { invoiceId: string; invoice: any }) => InvoiceService.approveInvocie(invoiceId, invoice),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useRejectInvocie = (): UseMutationResult<any, Error, { invoiceId: string; invoice: any }, void> =>
  useMutation(
    ({ invoiceId, invoice }: { invoiceId: string; invoice: any }) => InvoiceService.rejectInvocie(invoiceId, invoice),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useDeleteInvocie = (): UseMutationResult<any, Error, { invoiceId: string; invoice: any }, void> =>
  useMutation(
    ({ invoiceId, invoice }: { invoiceId: string; invoice: any }) => InvoiceService.deleteInvocie(invoiceId, invoice),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useProcessBilling = (): UseMutationResult<
  any,
  Error,
  {
    action: string;
    query: {
      status?: string[];
      companyId?: string;
      employmentType?: string;
      changeType?: string;
      employmentStatus?: string;
      clientName?: string[];
      hireType?: string;
      workerName?: string;
      dateRangeType?: string;
      startDate?: string | null;
      endDate?: string | null;
    };
  }
> => {
  const queryClient = useQueryClient();

  return useMutation(payload => InvoiceService.processBilling(payload), {
    onSuccess: () => {
      // 🔥 THIS refreshes the invoice list
      queryClient.invalidateQueries({
        queryKey: ['invoice-list'],
      });
    },

    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
};

export const useProcessPay = (): UseMutationResult<
  any,
  Error,
  {
    action: string;
    query: {
      status?: string[];
      companyId?: string;
      employmentType?: string;
      changeType?: string;
      employmentStatus?: string;
      clientName?: string[];
      hireType?: string;
      workerName?: string;
      dateRangeType?: string;
      startDate?: string | null;
      endDate?: string | null;
    };
  }
> => {
  const queryClient = useQueryClient();

  return useMutation(payload => InvoiceService.processPay(payload), {
    onSuccess: () => {
      // 🔄 refresh invoice list after pay processing
      // queryClient.invalidateQueries({
      //   queryKey: ['invoice-list'],

      // });

      queryClient.invalidateQueries({ queryKey: ['invoice-pay-list'] });
    },

    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
};
